const usdCurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export const defaultFormatCurrency = (value: number) =>
  usdCurrencyFormatter.format(value);
